import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../../../../../shared/presentations/PageNotFound";
import UsersPage from "./pages/UsersPage";

export const UsersRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + "/"} exact={true}><UsersPage /></Route>
      <Route ><PageNotFound /></Route>
    </Switch>
  );
};
